import { Form, Select } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React from 'react';
import { getMaxExp } from '../../../utils/get-max-exp';
import { TASelect } from '../../ta-select';
import constants from '../constants';
import keywordsList from '../../../constants/keywords';
import skillsList from '../../../constants/skills';
import { TAInput } from '../../widgets';

const { Option } = Select;

export const JobToCandidateForm = React.forwardRef<any, any>(({ onSubmit }, ref) => {
	const [form] = useForm();

	const onFinish = values => {
		if (values.minExp && !values.maxExp) values.maxExp = getMaxExp(values.minExp);
		onSubmit(values);
		form.resetFields();
	};
	return (
		<Form name="matchJob" layout="vertical" className="ta-form" ref={ref} onFinish={onFinish}>
			<Form.Item
				name="title"
				required
				label="Title"
				rules={[{ required: true, message: 'Please add job title' }]}
			>
				<TAInput placeholder="Job title" type="text" />
			</Form.Item>

			<Form.Item
				name="careerLevel"
				required
				label="Career Level"
				rules={[{ required: true, message: 'Please choose job career level' }]}
			>
				<TASelect>
					{Object.values(constants.CareerLevels).map(c => (
						<TASelect.Option value={c} key={c}>
							{c}
						</TASelect.Option>
					))}
				</TASelect>
			</Form.Item>

			<Form.Item
				name="skills"
				required
				label="Skills"
				rules={[{ required: true, message: 'Please add required job Skills' }]}
			>
				<TASelect mode="tags" placeholder="Add required skills">
					{Object.values(skillsList).map(skill => (
						<TASelect.Option value={skill} key={skill}>
							{skill}
						</TASelect.Option>
					))}
				</TASelect>
			</Form.Item>
			<p style={{ fontWeight: 500 }}>Experience</p>
			<div className="d-flex justify-content-between">
				<Form.Item
					name="minExp"
					label="Min"
					rules={[{ required: true, message: 'Please add minimum job experience' }]}
					wrapperCol={{ span: 23 }}
					className="d-inline-block w-100"
				>
					<TAInput type="number" min={0} placeholder="Minimum years of experience" />
				</Form.Item>

				<Form.Item
					wrapperCol={{ span: 23, offset: 1 }}
					className="d-inline-block w-100"
					name="maxExp"
					label="Max"
					rules={[
						{
							validator: (rule, value, callback) => {
								const minExp = form.getFieldValue('minExp');
								if (value && +value < +minExp)
									callback("Maximum experience can't be less than minimum experience.");
								else callback();
							}
						}
					]}
				>
					<TAInput type="number" min={0} placeholder="optional: max years of exp" />
				</Form.Item>
			</div>

			<Form.Item name="maxSalary" label="Maximum Salary">
				<TAInput type="number" min={1} placeholder="Add job's maximum budget (in EGP)" />
			</Form.Item>
			<Form.Item name="keywords" label="Keywords">
				<TASelect mode="tags" placeholder="Add Keywords, may enhance matching">
					{Object.values(keywordsList).map(keyword => (
						<Option value={keyword} key={keyword}>
							{keyword}
						</Option>
					))}
				</TASelect>
			</Form.Item>

			{/* <Form.Item name="description" label="Job Description">
				<TATextArea maxLength={1000} rows={4} placeholder="Add job description, may enhance matching" />
			</Form.Item> */}
		</Form>
	);
});
